import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Container from 'components/Container';
import Price from 'components/Price';
import ResponsiveImage from 'components/ResponsiveImage';
import { ArrowRightIcon } from 'components/icons';

/** One ingredient, told properly: photo, what it does, and where it is used. */
export default function IngredientBlock({ block }) {
  const { t } = useTranslation();
  const id = `blk-${block.id}`;
  return (
    <section aria-labelledby={id} className="py-16 lg:py-28">
      <Container className="grid items-center gap-10 lg:grid-cols-12 lg:gap-14">
        <div className="overflow-hidden rounded-lg bg-surface-alt lg:col-span-5">
          <ResponsiveImage
            image={block.image}
            sizes="(min-width: 1024px) 40vw, 100vw"
            className="aspect-[5/4] h-full w-full object-cover sm:aspect-[4/3] lg:aspect-[4/5]"
          />
        </div>
        <div className="lg:col-span-6 lg:col-start-7">
          {block.eyebrow && <p className="eyebrow mb-4">{block.eyebrow}</p>}
          <h2 id={id} className="font-display text-[2rem] leading-[1.08] text-ink sm:text-5xl">
            {block.title}
          </h2>
          <p className="mt-6 text-pretty text-[17px] leading-relaxed text-muted">{block.body}</p>
          {block.facts && (
            <dl className="mt-8 border-t border-border">
              {block.facts.map((f) => (
                <div key={f.label} className="grid gap-1 border-b border-border py-4 sm:grid-cols-[13rem_1fr] sm:gap-6">
                  <dt className="text-[13px] text-muted">{f.label}</dt>
                  <dd className="text-[15px] text-ink">{f.value}</dd>
                </div>
              ))}
            </dl>
          )}
          {block.products && block.products.length > 0 && (
            <div className="mt-8">
              <p className="text-[13px] font-semibold text-ink">{t('home.foundIn')}</p>
              <ul className="mt-3 grid gap-2">
                {block.products.map((p) => (
                  <li key={p.id}>
                    <Link
                      to={`/produk/${p.slug}`}
                      className="group flex items-center gap-4 rounded border border-border bg-surface p-2 pr-4 transition-colors hover:border-ink/40"
                    >
                      <span className="h-14 w-11 shrink-0 overflow-hidden rounded-sm bg-surface-alt">
                        <ResponsiveImage image={p.image} alt="" sizes="44px" className="h-full w-full object-cover" />
                      </span>
                      <span className="min-w-0 flex-1 text-[15px] font-medium text-ink">{p.name}</span>
                      <Price amount={p.priceAmount} compareAt={p.compareAtAmount} from={p.priceVaries} size="sm" className="hidden sm:inline-flex" />
                      <ArrowRightIcon className="h-4 w-4 shrink-0 text-muted transition-transform group-hover:translate-x-0.5" />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </Container>
    </section>
  );
}
